namespace $.$$ {

	export class $shm_agent_app_sessions_head extends $.$shm_agent_app_sessions_head {

		controls() {
			return this.search_showed() ? [ this.Filter() ] : []
		}

	}

}
